module.exports = __webpack_public_path__ + "static/media/bfrise.9306a4f1.png";